module.exports = __webpack_public_path__ + "img/escola_creative_learning_alimentacao.33257af8.jpeg";